import { DmsObjectName, dmsObjectNameDirective } from './DmsObjectName';
export { DmsObjectName, dmsObjectNameDirective };
